import { t } from "i18next";
import {
  EMAIL_VALIDATOR,
  PHONE_VALIDATOR,
  LENGTH_VALIDATOR,
  MAX_LENGTH_VALIDATOR,
  MIN_VALIDATOR,
  ZIP_CODE_VALIDATOR,
  PASSWORD_VALIDATOR,
  PASSWORDS_DO_NOT_MATCH,
  EMAIL_DO_NOT_MATCH,
  NIP_VALIDATOR,
  TEXT_VALIDATOR,
  REQUIRED_VALIDATOR,
} from "../../messages/errorsMessages";

/** Maksymalna długość imienia i nazwiska (zgodnie z limitem API / UX). */
export const PERSON_NAME_MAX_LENGTH = 50;

export const maxLengthRule = (max: number) => ({
  maxLength: {
    value: max,
    message: MAX_LENGTH_VALIDATOR(t, max),
  },
});

export const phoneValidator = (required: boolean) => ({
  required: required ? REQUIRED_VALIDATOR(t) : false,
  pattern: {
    value: /^([+][0-9]{2}[.-]?)?[0-9]{3}([.-]?)[0-9]{3}([.-]?)[0-9]{3}$/,
    message: PHONE_VALIDATOR(t),
  },
});

export const emailValidator = (required: boolean) => ({
  required: required ? REQUIRED_VALIDATOR(t) : false,
  pattern: {
    value: /(^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$)|^$/,
    message: EMAIL_VALIDATOR(t),
  },
});

export const textValidator = (required: boolean, minLength: number, maxLength?: number) => ({
  required: required ? REQUIRED_VALIDATOR(t) : false,
  pattern: {
    value:
      /^(?=.*[^ ,.'-])[[0-9a-zA-śŚZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/,
    message: TEXT_VALIDATOR(t),
  },
  minLength: {
    value: minLength,
    message: LENGTH_VALIDATOR(t, minLength),
  },
  ...(maxLength !== undefined ? maxLengthRule(maxLength) : {}),
});

export const lengthValidator = (required: boolean, minLength: number, maxLength?: number) => ({
  required: required ? REQUIRED_VALIDATOR(t) : false,
  minLength: {
    value: minLength,
    message: LENGTH_VALIDATOR(t, minLength),
  },
  ...(maxLength !== undefined ? maxLengthRule(maxLength) : {}),
});

export const minValue = (required: boolean, min: number) => ({
  required: required ? REQUIRED_VALIDATOR(t) : false,
  min: {
    value: min,
    message: MIN_VALIDATOR(t, min),
  },
});

export const zipCodeValidator = (required: boolean) => ({
  required: required ? REQUIRED_VALIDATOR(t) : false,
  pattern: {
    value: /\d{2}-\d{3}/,
    message: ZIP_CODE_VALIDATOR(t),
  },
});

export const passValidator = (required: boolean) => ({
  required: required ? REQUIRED_VALIDATOR(t) : false,
  pattern: {
    value: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,64}$/,
    message: PASSWORD_VALIDATOR(t),
  },
});

export const nipValidator = (required: boolean, isValidationActive: boolean) => ({
  required,
  pattern:
    isValidationActive === true
      ? {
          value: /(([0-9]{10}))|^$/,
          message: NIP_VALIDATOR(t),
        }
      : {},
});

export const repeatPassValidator = (required: boolean, currentValue: string) => ({
  required,
  validate: (value: string) => value === currentValue || PASSWORDS_DO_NOT_MATCH(t),
});

export const repeatEmailValidator = (required: boolean, currentValue: string) => ({
  required,
  validate: (value: string) => value === currentValue || EMAIL_DO_NOT_MATCH(t),
});
